import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { EntriModule, ModalsModule } from '../../../../ModalsExtensions';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { entriConnectAction } from '../../entriConnectAction';
import { EntriFlowStatus, parseDomain } from '@wix/domains-serverless-interface';
export const domainIsTakenHandler = async _ref => {
  let {
    domainName,
    msid,
    siteName,
    externalViewer,
    fullPage,
    t
  } = _ref;
  const {
    main
  } = parseDomain(domainName);
  const {
    httpClient
  } = getPremiumEssentials();
  const canChangeOwnerReq = fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
    httpClient: httpClient,
    request: {
      domain: main
    }
  }), {
    canChangeOwner: false
  });
  const {
    loaderModal
  } = ModalsModule.internals.domainsSharedModalsController;
  loaderModal.show({});
  const {
    canChangeOwner
  } = await canChangeOwnerReq;
  const domainTakenInWixEntri = await DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
    httpClient: httpClient,
    request: {
      domain: main
    }
  });
  loaderModal.hide();
  if (domainTakenInWixEntri.isEligible) {
    const entriCallback = async () => {
      return entriConnectAction({
        domainName: main,
        msid,
        siteName: siteName ?? '',
        overrideEntriEligibility: domainTakenInWixEntri,
        isNonWixEditorSite: externalViewer,
        fullPage,
        t
      });
    };
    const result = await entriCallback();
    switch (result.status) {
      case EntriFlowStatus.manual:
        EntriModule.internals.domainsEntriModalsController.domainTakenInWixEntriModal.show({
          connectHandler: async () => {
            await entriCallback();
          }
        });
        // undefined keeps the caller on the modal instead of the manual connect flow
        return undefined;
    }
    return result.status;
  }
  if (canChangeOwner) {
    return EntriFlowStatus.manual;
  }
  loaderModal.hide();
  ModalsModule.internals.domainsActionsModalsController.domainTakenInWix.show({
    domain: domainName
  });
  return undefined;
};
//# sourceMappingURL=DomainIsTakenHandler.js.map